/**
 * @module FE-CU34_アカウント管理ユーザー情報画面
 */
import Header from '../../../components/header/Header.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import NormalButton from '../../../components/button/Normal.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU34';

export default {
  name: 'UserInfoAccountManagement',
  components: {
    Header,
    PcPageTitle,
    BreadCrumbList,
    NormalButton,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t(
        '$vuetify.FECU34アカウント管理ユーザー情報画面.アカウント管理ユーザー情報'
      ),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU34アカウント管理ユーザー情報画面.C0001'
      ),
      userInfo: {
        name: '', // 氏名
        gender: null, // 性別
        birthyear: null, // 生年
        userId: '', // ユーザーID
      },
      width: 0,
      takeoverFlg: false,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t(
          '$vuetify.FECU34アカウント管理ユーザー情報画面.アカウント管理ユーザー情報'
        ),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU34アカウント管理ユーザー情報画面.C0001'
        ),
      };
    },
    /**
     * ヘッダーに戻るボタンを表示するか
     * @returns {boolean} ヘッダーに戻るボタンを表示するか
     * @description アプリから遷移した場合は戻るボタンを表示しない
     */
    displayBackButton() {
      return this.$mq === 'pc' ? true : !(this.$route.query.takeoverToken && this.$isBrowser);
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    init: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     userInfo: {
            //       name: "山田太郎",
            //       gender: 1,
            //       birthyear: 1990,
            //       userId: "test@example.com",
            //     },
            //   },
            // };

            // 取得したデータを画面に出力する。
            this.userInfo = apiData.contentsInfo.userInfo;
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * FE-CU47_ユーザー情報変更画面（氏名, 電話番号）へ遷移
     */
    replaceChangeUserInfoOfPersonalData: function () {
      this.$router.push('changeUserInfoOfPersonalData');
    },
    /**
     * FE-CU48_ユーザー情報変更画面（メールアドレス）へ遷移
     */
    replaceChangeUserInfoOfUserId: function () {
      this.$router.push('changeUserInfoOfUserId');
    },
    /**
     * FE-CU49_ユーザー情報変更画面(パスワード)へ遷移
     */
    replaceChangeUserInfoOfPassword: function () {
      this.$router.push('changeUserInfoOfPassword');
    },
    /**
     * FE-CU50_ユーザー情報変更（秘密の質問）へ遷移
     */
    replaceChangeUserInfoOfSecretQuestion: function () {
      this.$router.push('changeUserInfoOfSecretQuestion');
    },
    /**
     * FE-CU51_アカウント削除画面へ遷移
     */
    replaceAccountDelete: function () {
      this.$router.push('accountDelete');
    },
    /**
     * 画面サイズ(幅)変更処理
     * @param {*} width 画面サイズ(幅)
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
    /**
     * ユーザー権限一覧取得API実行処理
     */
    async APP_CU9916() {
      let param = '/api/common/getRoleList';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';
      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: {
            //       customerNumber: "sendCustomerNumber",
            //       districtSplitNumber: "sendCustomerNumber",
            //       displayDistrictUserType: 1,
            //       userAuthority: {
            //         securityOperation: true,
            //         rushOrder: true,
            //         notificationHistory: true,
            //         deviceContorol: true,
            //         contact: true,
            //         nicknameSetting: true,
            //         IDCardKeyInfoSetting: true,
            //         watchOverInfoDeliverySetting: true,
            //         lockUpCheck: true,
            //         targetAtHomeSetting: true,
            //         userManagement: true,
            //         emergencyContact: true,
            //       },
            //     },
            //     cameraInfoList: {
            //       customerNumber: "customerNumber",
            //       districtSplitNumber: "districtSplitNumber",
            //       deviceID: "deviceID",
            //       cameraUserType: 0,
            //       userAuthority: {
            //         anticrimeCameraVideos: false,
            //         rushOrder: false,
            //         notificationHistory: false,
            //         contact: false,
            //         nicknameSetting: false,
            //         userManagement: false,
            //         emergencyContact: false,
            //       },
            //     },
            //   },
            // };

            if (apiData.contentsInfo.displayDistrictInfoList.length != 0) {
              this.$store.state.isTopHomeSecurityActive = true;
            }

            if (apiData.contentsInfo.cameraInfoList.length != 0) {
              this.$store.state.isTopCameraActive = true;
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
    },
    /**
     * 継続ログイン認証API実行処理
     */
    async APP_CU9913() {
      let param = '/api/common/continueLogin';
      let queries = {
        takeOverToken: this.$route.query.takeoverToken,
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo:{
            //     loginResult: 0   // 0: ログイン成功 | 1: 2段階認証が必要 | 2: ログイン失敗
            //   },
            //   token: "string"
            // }
            this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: true });
            switch (apiData.contentsInfo.loginResult) {
              case 0: {
                this.$store.commit('setIsLoggedIn', { isLoggedIn: true });
                sessionStorage.setItem('token', apiData.token);
                // 権限取得APP_CU9916
                await this.APP_CU9916();
                let param = '/api/userInfoAccountManagement/init';
                let queries = {
                  token: sessionStorage.getItem('token'),
                  terminalInfo: localStorage.getItem('terminalInfo')
                    ? localStorage.getItem('terminalInfo')
                    : '', //端末情報
                };
                let method = 'post';
                await this.init(param, queries, method);

                if (this.$store.getters['isLoggedIn']) {
                  await this.$refs.header.APP_CU0201();
                }
                break;
              }
              case 1: {
                let handoverToken = apiData.token;
                this.$router.push({
                  path: '/twoStepAuthentication',
                  query: {
                    handoverToken: handoverToken,
                    targetPage: '/userInfoAccountManagement',
                  },
                });
                break;
              }
              case 2: {
                this.$_abnormality(500);
                break;
              }
              default: {
                this.$_abnormality(500);
                break;
              }
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // アプリから遷移時orリロード時
      if (from.path == '/') {
        vm.takeoverFlg = true;
        next();
      } else {
        next();
      }
    });
  },
  async mounted() {
    if (this.$route.query.takeoverToken && this.$isBrowser && this.takeoverFlg) {
      this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: false });
    }
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.changeItemLabelWidth(
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
    );
    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    // 継続ログイン認証APP_CU9913
    if (this.$route.query.takeoverToken && this.$isBrowser && !this.$store.state.takeoverTokenFlg) {
      await this.APP_CU9913();
    } else {
      this.$store.commit('setTakeoverTokenFlg', { takeoverTokenFlg: true });
      let param = '/api/userInfoAccountManagement/init';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '', //端末情報
      };

      let method = 'post';
      await this.init(param, queries, method);

      if (this.$store.getters['isLoggedIn']) {
        await this.$refs.header.APP_CU0201();
      }
    }

    // 通信中にローディングマークの裏で画面が崩れるので、通信が終わってからに修正
    this.isShowPage = true;
  },
};
